import { action, computed } from 'mobx';
import { Entity } from '../../core/entity';
import type { ICenterLineViewModel } from '../interfaces';
import type { SliceType } from '../modules/images/interfaces';

export interface CenterLineViewModelProps {
  descriptor: string;
  color: string;
  selectionColor: string;
  isSelected: boolean;
  isHighlighted: boolean;
  isVisible: boolean;
  alongSliceDescriptor: SliceType;
}

export class CenterlineViewModel extends Entity<CenterLineViewModelProps> implements ICenterLineViewModel {
  public get descriptor(): string {
    return this.props.descriptor;
  }

  @computed
  public get color(): string {
    return this.props.color;
  }

  @computed
  public get selectionColor(): string {
    return this.props.selectionColor;
  }

  @computed
  public get alongSliceDescriptor(): SliceType {
    return this.props.alongSliceDescriptor;
  }

  @computed
  public get isHighlighted(): boolean {
    return this.props.isHighlighted;
  }

  @computed
  public get isSelected(): boolean {
    return this.props.isSelected;
  }

  @computed
  public get isVisible(): boolean {
    return this.props.isVisible;
  }

  @action
  public setHighlighting(highlighting: boolean): void {
    this.props.isHighlighted = highlighting;
  }

  @action
  public setSelection(selected: boolean): void {
    this.props.isSelected = selected;
  }

  @action
  public setVisibility(visible: boolean): void {
    this.props.isVisible = visible;
  }
}
